module.exports = __webpack_public_path__ + "img/IMG_5410.08e986b1.jpg";